<template>
  <div class="page-dialog">
    <el-descriptions class="margin-bottom" title="" :column="3" border>
      <el-descriptions-item label="客户名称">{{ rowData.name }}</el-descriptions-item>
      <el-descriptions-item label="计划年度">{{ rowData.annual }}</el-descriptions-item>
      <el-descriptions-item label="计划月度">{{ rowData.monthly }}</el-descriptions-item>
      <el-descriptions-item label="存货分类名称">{{ rowData.brandName }}</el-descriptions-item>
      <el-descriptions-item label="渠道类型">{{ rowData.zqdlxTextView }}</el-descriptions-item>
      <el-descriptions-item label="营销单元">{{ rowData.zyxdyName }}</el-descriptions-item>
    </el-descriptions>

    <div class="table-container">
      <TableCommon
        :show-header="false"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="400"
          align="center"
          size="medium"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiFindAdjustmentHistory } from '@/api/applyForGoods/monthly'

export default {
  props: {
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      conditions: {},
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'createdDate', title: '调整时间', width: 100 },
          { field: 'createdByName', title: '调整人', width: 100 },
          { field: 'annual', title: '实际年度', width: 100 },
          { field: 'monthly', title: '月份', width: 100 },
          { field: 'deliveryNum', title: '计划量', width: 100 },
          { field: 'approvingNum', title: '发货量(审核中)', width: 120 },
          { field: 'usedNum', title: '发货中(归档中)', width: 120 },
          { field: 'remainNum', title: '剩余量', width: 100 },
          { field: 'adjustDeliveryNum', title: '本次调整量', width: 100 },
          { field: 'finalNum', title: '调整计后量', width: 100 },
          { field: 'adjustReason', title: '变更原因', width: 100 }
        ],
        data: []
      }
    }
  },
  created() {
    if (this.rowData.detailItemId) {
      apiFindAdjustmentHistory(this.rowData).then(res => {
        const { data } = res
        this.gridOptions.data = data
      })
    }
  },
  methods: {}
}
</script>

<style>
.margin-bottom{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/components/MonthlyHistory.vue